import { render, staticRenderFns } from "./CurriculumCard.vue?vue&type=template&id=128c58e8&scoped=true"
import script from "./CurriculumCard.vue?vue&type=script&lang=js"
export * from "./CurriculumCard.vue?vue&type=script&lang=js"
import style0 from "./CurriculumCard.vue?vue&type=style&index=0&id=128c58e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c58e8",
  null
  
)

export default component.exports